import Vue from 'vue'
import App from './App.vue'
import store from "./store"
import router from './router'
import VueHead from 'vue-head'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueHead)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = true

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
